export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9515.26d02c91.jpg";